import { render, staticRenderFns } from "./historicContent.vue?vue&type=template&id=c85246f6&"
import script from "./historicContent.vue?vue&type=script&lang=js&"
export * from "./historicContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports